import { render, staticRenderFns } from "./CollectionExchangeDetail.vue?vue&type=template&id=5667fdd6&scoped=true"
import script from "./CollectionExchangeDetail.vue?vue&type=script&lang=js"
export * from "./CollectionExchangeDetail.vue?vue&type=script&lang=js"
import style0 from "./CollectionExchangeDetail.vue?vue&type=style&index=0&id=5667fdd6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5667fdd6",
  null
  
)

export default component.exports